import { buildErrorMessageFromDataApiResponse } from "../util/ErrorMessage"

export class RequestErrorDataApi extends Error {
    public status: number
    public response?: Response

    constructor(message: string, status: number, response?: Response) {
        super(message)
        this.name = "RequestErrorDataApi"
        this.status = status
        this.response = response

        // Set the prototype explicitly, necessary when extending built-in classes in TypeScript
        Object.setPrototypeOf(this, RequestErrorDataApi.prototype)
    }

    private async initializeFullMessage(
        message: string,
        response?: Response,
    ): Promise<void> {
        if (!response) {
            return
        }
        this.message = await buildErrorMessageFromDataApiResponse(
            message,
            response,
        )
    }
    public static async create(
        message: string,
        status: number,
        response?: Response,
    ): Promise<RequestErrorDataApi> {
        const error = new RequestErrorDataApi(message, status, response)
        await error.initializeFullMessage(message, response)
        return error
    }
}
